<div class="row m-0 pt-5">
	<div class="col-lg-12">
		<div class="pl-3 pr-3 mt-4">
			<span class="py-3">
				<h4>Personal Area</h4>
			</span>
		</div>

		<mat-card class="card-top my-3 d-flex justify-content-between">
			<span>Results of massive submission</span>
			<span *ngIf="files && files.count > 0">
				{{ files.count }}
				<span *ngIf="files.count === 1">item</span>
				<span *ngIf="files.count > 1">items</span>
			</span>
		</mat-card>

		<mat-card *ngFor="let item of filesList" class="d-flex justify-content-between mb-3 p-4">
			<div *ngIf="!item.is_readed" class="new-badge">
				<span>NEW</span>
			</div>
			<button mat-stroked-button class="bg-white btn-border" (click)="downloadZip(item)">
				Download Zip Folder
			</button>
			<div class="d-flex flex-column text-center justify-content-center">
				<span class="d-block">Last edit:</span>
				<span>{{ item.last_reading_date }}</span>
			</div>
			<div class="d-flex flex-column text-center justify-content-center">
				<span class="d-block">Submitted by:</span>
				<span>{{ item.user }}</span>
			</div>
			<div class="d-flex flex-column text-center justify-content-center">
				<i class="fas fa-file-archive d-block icon-file"></i>
				<span>{{ item.type }}</span>
			</div>
		</mat-card>
	</div>
</div>
